var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reference-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy",
    width: 25,
    height: 25,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48145 6.88358C4.48145 4.28473 6.63508 2.18652 9.28145 2.18652C11.9278 2.18652 14.0814 4.28473 14.0814 6.88358C14.0814 9.48243 11.9278 11.5806 9.28145 11.5806C6.63508 11.5806 4.48145 9.48243 4.48145 6.88358ZM12.4814 6.88358C12.4814 5.17786 11.0534 3.78652 9.28145 3.78652C7.50953 3.78652 6.08145 5.17786 6.08145 6.88358C6.08145 8.5893 7.50953 9.98064 9.28145 9.98064C11.0534 9.98064 12.4814 8.5893 12.4814 6.88358Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5757 18.7812C16.7343 18.5316 15.9855 18.0664 15.3933 17.4498C15.7689 18.1726 16.0254 18.9671 16.1371 19.8074L16.1552 19.9641H1.8442L1.8633 19.8074C2.33151 16.2836 5.34835 13.5648 9.0002 13.5648L9.24269 13.5689C11.3208 13.6376 13.1759 14.587 14.4469 16.0558C14.16 15.4254 14.0002 14.7249 14.0002 13.9871C14.0002 13.8351 14.007 13.6847 14.0202 13.5362C12.5965 12.5456 10.8662 11.9648 9.0002 11.9648C4.14009 11.9648 0.200195 15.9047 0.200195 20.7648C0.200195 21.2067 0.558368 21.5648 1.0002 21.5648H17.0002C17.442 21.5648 17.8002 21.2067 17.8002 20.7648C17.8002 20.0827 17.7226 19.4187 17.5757 18.7812Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8604 13.826C12.8604 10.593 15.5213 7.97754 18.7966 7.97754C22.0717 7.97754 24.732 10.5929 24.732 13.826C24.732 17.0589 22.0719 19.6736 18.7966 19.6736C15.5212 19.6736 12.8604 17.0588 12.8604 13.826ZM23.132 13.826C23.132 11.4827 21.1941 9.57754 18.7966 9.57754C16.3989 9.57754 14.4604 11.4829 14.4604 13.826C14.4604 16.1689 16.3987 18.0736 18.7966 18.0736C21.1943 18.0736 23.132 16.169 23.132 13.826Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 15",
    d: "M20.8477 13.0488C21.1791 13.0488 21.4477 13.3175 21.4477 13.6488C21.4477 13.9471 21.2301 14.1945 20.9451 14.241L20.8477 14.2488H16.7436C16.4122 14.2488 16.1436 13.9802 16.1436 13.6488C16.1436 13.3506 16.3611 13.1032 16.6462 13.0567L16.7436 13.0488H20.8477Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 17",
    d: "M18.9084 11.5886C19.1149 11.3785 19.438 11.3526 19.6732 11.5126L19.7569 11.5813L21.4079 13.204C21.6205 13.413 21.6441 13.7409 21.4787 13.9763L21.4079 14.0598L19.5196 15.9158C19.2833 16.1481 18.9034 16.1448 18.6711 15.9085C18.4646 15.6984 18.4443 15.3749 18.6083 15.1425L18.6784 15.06L20.1311 13.6312L18.9157 12.4371C18.7056 12.2306 18.6797 11.9075 18.8397 11.6723L18.9084 11.5886Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.72b5f2e2986384a12abaeca51e62af89.svg";
export { ForwardRef as ReactComponent };